/* eslint-disable max-len */
export default {
  Settings: {
    SettingsDescription: 'Caregiver settings',
    ProfileUrl: {
      Title: 'Profile URL',
      Copy: 'Copy',
      Edit: 'Edit',
      GenerateLabel: 'Generate Client-Specific URL',
      GenerateCustom: {
        Title: 'Add a client-tailored description for this caregiver',
        RecommendationId: 'Recommendation ID',
        ErrorMessageRecommendationIdTaken: 'That recommendation ID is already being used. Please choose another one.',
        ErrorMessageDefault: 'An error occurred. Please try again.',
        CancelLabel: 'Cancel',
        GenerateLabel: 'Generate',
      },
      ShowCustom: {
        Title: 'Client-Specific URL',
        Copy: 'Copy',
      },
      EditDialog: {
        Action: 'Edit short ID',
        NewShortId: 'New short ID',
        ErrorMessageShortIdTaken: 'That short ID is already being used. Please choose another one.',
        ErrorMessageDefault: 'An error occurred. Please try again.',
      },
      InsufficientBioData: 'Profile URL will display when the following biography fields are filled out: #{missingFields}.',
      RequiredFields: {
        firstName: 'first name',
        lastName: 'last name',
        city: 'city',
        province: 'province',
        shortBio: 'short biography',
        personalBio: 'personal biography',
        caregiverMotivation: 'caregiver motivation',
      },
    },
    Contact: {
      Title: 'Contact',
      Copy: 'Copy',
      Delete: 'Delete',
      CreateNew: {
        Action: 'Add new contact',
        ContactType: 'Contact type',
        ContactDetail: 'Contact detail',
        ContactTypeExample: {
          Email: 'Email',
          PhoneNumber: 'Phone number',
          EmergencyContact: 'Emergency contact',
        },
      },
    },
    Auth: {
      Title: 'Authentication',
      SetupAuth: 'Setup authentication',
      ReactivateAuth: 'Reactivate authentication',
      RemoveAuth: 'Remove authentication',
      ResetPassword: 'Reset password',
      Email: 'Login email',
      Password: 'Password',
      RePassword: 'Re-enter Password',
      ReactivateAuthText: 'Would you like to reactivate their authentication?',
      Status: {
        Title: 'Status',
        UNCONFIRMED: 'User created but not confirmed.',
        CONFIRMED: 'User confirmed.',
        UNKNOWN: 'User status unknown.',
        RESET_REQUIRED: 'Confirmed, must change temporary password on first sign-in.',
        FORCE_CHANGE_PASSWORD: 'Confirmed, must change temporary password on first sign-in.',
        DEACTIVATED: 'User authentication deactivated',
      },
    },
  },
  Correspondance: {
    Title: 'Notes',
    Filter: 'Filter',
    Header: {
      Description: 'Description',
      LastAnnouncement: 'Last announcement',
    },
    Type: {
      Comments: 'Comments',
      Announcements: 'Announcements',
      Logs: 'Logs',
      Emails: 'Emails',
    },
    Sort: {
      NewestFirst: 'Newest first',
      OldestFirst: 'Oldest first',
    },
    NewMessage: {
      Comments: 'Comments',
      Announcements: 'Announce',
      Cancel: 'Cancel',
      AddACommentOrAnnouncements: 'Add a comment or announcement',
    },
    Correspondance: {
      AnnouncedOn: 'Announced on',
      CommentedOn: 'Commented on',
      Email: 'Email',
      EmailMetadata: {
        From: 'From',
        Subject: 'Subject',
        To: 'To',
        ReplyTo: 'Reply-To',
        Date: 'Date',
      },
      Logs: {
        CreatedOn: 'Created caregiver on',
        EditName: 'Edited name on',
        EditDescription: 'Edited description on',
        EditStatus: 'Edited status on',
        EditPhoto: 'Edited photo on',
        EditContact: 'Added contact on',
        RemoveContact: 'Removed contact on',
      },
    },
    Messages: {
      LoadMore: 'Load more',
    },
    Logs: {
      EditContact: {
        Text: `#{type} added: #{detail}`,
      },
      RemoveContact: {
        Text: `#{type} removed: #{detail}`,
      },
      EditStatus: {
        Text: `Status changed from #{oldStatus} to #{newStatus}`,
      },
      EditName: {
        Text: `Caregiver name changed from #{oldCaregiverName} to #{newCaregiverName}`,
      },
    },
  },
  Biography: {
    Title: 'Biography',
  },
  Scheduling: {
    Title: 'Scheduling',
    AddNewSchedule: 'Add new schedule',
    ScheduleSetupWizard: 'Schedule setup wizard',
    ScheduleDetail: {
      Action: {
        Back: 'Back',
        Next: 'Next',
        Review: 'Review',
        Create: 'Create',
        Close: 'Close',
      },
      SelectEventType: {
        Title: 'Event type',
        FixedEventTitle: 'Fixed Event',
        FixedEventExplain: 'Schedule this as a one-time event for a specific date and time.',
        RecurringEventTitle: 'Recurring Event',
        RecurringEventExplain: 'Set this event to repeat on a regular basis (e.g., daily, weekly, or monthly).',
      },
      EventInfo: {
        Title: 'Event name',
        Description: 'Description',
        NoDescription: 'No description',
      },
      EventDate: {
        FixedEvent: {
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
        },
        RecurrenceEvent: {
          StartDate: 'Start date',
          EndDate: 'End date',
          EndDateDisplay: 'End date or leave blank for infinity',
          Infinity: 'Infinity',
          Frequency: 'Frequency',
          FrequencyData: {
            DAILY: 'Daily',
            WEEKLY: 'WEEKLY',
            MONTHLY: 'MONTHLY',
            YEARLY: 'YEARLY',
          },
          Interval: 'Interval',
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
          DayOfTheWeek: {
            SU: 'S',
            MO: 'M',
            TU: 'T',
            WE: 'W',
            TH: 'T',
            FR: 'F',
            SA: 'S',
          },
          ByMonthDay: `By Month Day (e.g., 25)`,
          ByMonth: `By Month (e.g., 11)`,
        },
      },
      Breaks: {
        Title: 'Breaks',
        BreakDuration: 'Break duration',
        BreakCount: 'Break count',
        Minutes: '#{breakDuration} minutes',
      },
      Client: {
        ClientName: 'Client',
      },
    },
  },
  ClientConnections: {
    Title: 'Clients',
    SupportChat: {
      Title: 'Support chat',
      ChatLabel: 'CareQuilt support',
      Empty: 'No support conversations available yet.',
      ModalTitle: 'Support chat',
    },
    Chat: {
      TabTitle: 'Chats',
      Empty: 'No chats available yet.',
      OpenButton: 'Open chat',
      CareRecipient: 'Care recipient: #{name}',
      Attachment: 'Attachment',
      NoMessages: 'No messages yet.',
      UnknownSender: 'Unknown sender',
      DefaultTitle: 'Conversation',
      UnassignedChats: 'Unassigned Chats',
      UnknownRelationship: 'Unknown relationship',
      Family: 'Family chat',
      Relationship: 'Relationship',
      Members: 'Members: #{members}',
    },
    AddClient: {
      Title: 'Add client to roster',
      ClientSearch: 'Client',
      AddClient: 'Add client',
    },
    Client: {
      ClientName: 'Client name',
      Chat: {
        Title: 'Client chats',
        Empty: 'No chats found for this client.',
      },
    },
  },
  ChangeStatusDialog: {
    Title: 'Change status',
    Status: 'Status',
  },
  ChangeName: {
    Title: 'Change name',
    Name: 'Name',
  },
  Status: {
    Subtitles: {
      Created: 'Joined: #{value}',
      Updated: 'Updated: #{value}',
    },
    Metrics: {
      PhoneNumber: 'Phone Number',
      Email: 'Email',
    },
  },
  Tasks: {
    Title: 'Tasks',
    TabLabels: {
      Description: 'Description',
      DueDate: 'Due Date',
      CreateTask: 'Create Task',
    },
  },
  Payment: {
    Title: 'Payment',
    PaymentPlan: {
      Title: 'Payment details',
      HourlyRateTitle: 'Hourly rate',
      HourlyCost: '$#{hourlyRate}',
      NoHourlyRate: 'Hourly rate not set',
    },
    Expense: {
      Amount: '$#{expenses}',
    },
    PaymentSlip: {
      Title: 'Payment slip',
    },
    WeekOf: `Week of #{date} #{status}`,
    HoursDisplay: `#{hours} hrs`,
    CostDisplay: `$#{cost}`,
    WaitingConfirmation: 'Waiting confirmation',
    Complete: 'Complete',
    WorkSummary: {
      Title: 'Work summary',
      TotalHours: 'Total Hours',
      TotalCost: 'Total Cost',
      ConfirmedHours: 'Confirmed Hours',
      ConfirmedCost: 'Confirmed Cost',
      ShiftsScheduled: 'Shifts Scheduled',
      HoursScheduled: 'Hours Scheduled',
      ShiftsWorked: 'Shifts Worked',
      HoursWorkedTitle: 'Hours Worked',
      PayRate: 'Pay Rate',
      TotalExpenses: 'Total Expenses',
      TotalPay: 'Total Pay',
      WeeklyProgress: {
        Title: 'Weekly Progress',
        Earned: 'Earned',
        ShiftsCompleted: '#{workedShifts} of #{totalShifts} shifts completed',
        CompletionRate: '#{percentage}% completion rate',
        ShiftsCompletedWithRate: '#{workedShifts} of #{totalShifts} shifts completed • #{percentage}% completion rate',
      },
      HoursWorked: {
        Title: 'Hours worked',
        ShiftHeader: `#{date} - #{title}`,
        ClockIn: 'Clock-in',
        ClockOut: 'Clock-out',
        HourlyRate: '$#{hourlyRate}/hr',
      },
    },
  },
  Reviews: {
    Title: 'Reviews',
  },
  Interviews: {
    Title: 'Interviews',
    EmptyInterviews: 'No interviews found',
    Interview: 'Interview',
    Conversation: 'Conversation',
    ViewConversation: 'View Conversation',
  },
};
